import { render } from "./tarea.vue?vue&type=template&id=946293c6&scoped=true"
import script from "./tarea.vue?vue&type=script&lang=js"
export * from "./tarea.vue?vue&type=script&lang=js"

import "./tarea.vue?vue&type=style&index=0&id=946293c6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-946293c6"]])

export default __exports__